import Switch from './Switch';
export default Switch;
//# sourceMappingURL=index.js.map